/* eslint-disable react/no-danger */
/* eslint-disable no-nested-ternary */
import PropTypes from 'prop-types';

import useResponsive from '../../../utils/responsive';

import { FadeInAnimation, ParallaxComponent } from '../shared/index';

import BlogSection from '../home-page-components/blog-section.component';


const BlogPostBody = (props) => {
    const { data, page } = props;
    const { featured_image, featured_image_alt, paragraph } = data;
    const { isMobile, isTablet, isDesktop } = useResponsive();

    return (
        <>
            <div className='blog-post-body-blog-parallax-container'>

                <ParallaxComponent
                    src={featured_image}
                    alt={featured_image_alt || 'blog-article'}
                    isMobile={isMobile}
                    isTablet={isTablet}
                    isDesktop={isDesktop}
                    speed={0.1}
                    blog
                />

            </div>

            <div className='blog-post-body-blog-parallax-space' />

            <div className='blog-post-body-blog-parallax-base-container'>

                <div className='container-root container-root-maxWidthLg blog-post-body-container'>

                    <FadeInAnimation>

                        <div className='blog-post-body-body' dangerouslySetInnerHTML={{ __html: paragraph }} />

                    </FadeInAnimation>

                </div>

                <div className='blog-post-section-container'>

                    <div className='container-root container-root-maxWidthLg blog-carousel-container carousel-container-settings'>
                        
                        <BlogSection page={page} title="Related Articles" />

                    </div>

                </div>

            </div>
        </>
    );
};

export default BlogPostBody;

BlogPostBody.propTypes = {
    data: PropTypes.object,
    page: PropTypes.any,
};

